import React from "react";

import { Button } from "@replo/design-system/components/button/Button";
import { Tooltip } from "@replo/design-system/components/tooltip/Tooltip";
import { useChatSidebar } from "@v2/features/chat/hooks/useChatSidebar";
import { useCurrentChatContext } from "@v2/features/chat/providers/CurrentChatContext";
import { PanelLeft } from "lucide-react";

function ChatHeader({ showTitle = true }: { showTitle?: boolean }) {
  const { chat, isGeneratingTitle } = useCurrentChatContext();
  const { open: isChatSidebarOpen, toggle: toggleChatSidebar } =
    useChatSidebar();

  let content;
  if (isGeneratingTitle) {
    content = (
      <div className="flex items-center gap-2 text-sm font-medium">
        <span
          className="text-muted"
          style={{ animation: "pulse 1.5s ease-in-out infinite" }}
        >
          Generating title...
        </span>
      </div>
    );
  } else if (showTitle) {
    content = (
      <div className="text-sm font-semibold line-clamp-1">
        {chat?.title ?? "New Chat"}
      </div>
    );
  }

  return (
    <div className="relative w-full">
      <div className="absolute z-5 flex flex-row items-center gap-3 pl-1.5 md:pl-0">
        <Tooltip
          content={isChatSidebarOpen ? "Close chats" : "Show all chats"}
          triggerAsChild
        >
          <Button
            icon
            variant="secondary"
            UNSAFE_className="hidden md:flex"
            onClick={toggleChatSidebar}
          >
            <PanelLeft />
          </Button>
        </Tooltip>
        {content}
      </div>
    </div>
  );
}

export default ChatHeader;
